/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import LoadingPage from "components/common_components/LoadingPage";
import { useDispatch } from "react-redux";
import { notifyError, notifyInfo } from "redux/actions/Notifications";
import clsx from "clsx";
import Button from "components/common_components/Button";
import Icon from "components/common_components/Icon";
import EnhancedTable from "components/common_components/Tables/EnhancedTable";
import { hasElements } from "utils/arrays";
import ChainOfCustodyContext from "../ChainOfCustodyContext";

const headCells = [
    { index: 1, id: "module", label: "Module" },
    { index: 2, id: "fileNo", label: "File No." },
];

const FileCases = ({ visible, onBackClick, onFileCaseSelected, client, error }) => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const { Customers } = useContext(ChainOfCustodyContext);

    function getFileCases() {
        setIsLoading(true);
        Customers.getFileCases({
            id: client.id,
            onSuccess: (data) => {
                setData(data);
                setIsLoading(false);
            },
            onInfo: (info) => {
                dispatch(notifyInfo(info));
                setIsLoading(false);
            },
            onError: (error) => {
                dispatch(notifyError(error));
                setIsLoading(false);
            },
        });
    }

    useEffect(() => {
        if (visible) {
            getFileCases();
        } else {
            setData([]);
        }

        return () => {
            setData([]);
        };
    }, [visible]);

    return (
        <div
            className={clsx("layout clients-container", {
                visible: visible,
                invisible: !visible,
            })}
        >
            {visible && (
                <>
                    <Button secondary link onClick={onBackClick}>
                        <Icon name="arrow" color="secondary" size="xs" />
                        <span>Back</span>
                    </Button>
                    <hr />
                    <h3>Client's Case</h3>
                    <small>
                        <i>Select the client's case</i>
                    </small>

                    <div className="clients">
                        {isLoading && <LoadingPage />}
                        {!isLoading && hasElements(data) && (
                            <EnhancedTable
                                headCells={headCells}
                                data={data}
                                keyColumnName="fileCaseId"
                                selectable={false}
                                deletable={false}
                                filterable={false}
                                orderable={false}
                                pageable={false}
                                onRowClick={onFileCaseSelected}
                                onRequestData={getFileCases}
                            />
                        )}
                    </div>

                    {error && <div className="wizard-error">{error}</div>}
                </>
            )}
        </div>
    );
};

FileCases.propTypes = {
    client: PropTypes.object,
    visible: PropTypes.bool,
    onBackClick: PropTypes.func,
    onFileCaseSelected: PropTypes.func,
    error: PropTypes.string,
};

FileCases.defaultProps = {
    client: {},
    visible: false,
    onBackClick: () => {},
    onFileCaseSelected: () => {},
    error: undefined,
};

export default FileCases;
